var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{class:_vm.loadingType==='fixed'?'fixed':'absolute',on:{"mousewheel":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"loading"},[_c('a-icon',{attrs:{"type":"sync","spin":""}})],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69b5b694","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/component/LoadingMask.vue
// module id = null
// module chunks = 